import { Collapse, Modal } from 'antd';
import moment from 'moment';
import React from 'react';

const { Panel } = Collapse;

const MentenancePlanningHistoryModal = ({ visible, maintenances, onClose }: any) => {
  // Filter maintenances with statusId of 5
  const filteredMaintenances = maintenances?.filter((maintenance: any) => maintenance.statusId === 4);

  return (
    <Modal title='Istoric' open={visible} onCancel={onClose} footer={null} width={800}>
      <Collapse>
        {filteredMaintenances?.length > 0 ? (
          filteredMaintenances.map((maintenance: any, index: any) => (
            <Panel
              header={
                <span style={{ color: maintenance.history.includes('[Cerere reprogramare]') ? 'red' : 'inherit' }}>
                  {/* Display registeredByUser only if it exists */}
                  {maintenance.registeredByUser?.name && `[${maintenance.registeredByUser.name}]`}
                  {/* Display date */}
                  {` [${moment(maintenance.interventionFile.deliveryDate).format('DD-MM-YYYY')}]`}
                  {/* Display assignedTechnician only if it exists */}
                  {maintenance.assignedTechnician?.name &&
                    `[TEHNICIAN ASIGNAT - ${maintenance.assignedTechnician.name}] `}
                  {/* Display system types only if they exist */}
                  {maintenance.mentenancePlanningSystemTypes &&
                    maintenance.mentenancePlanningSystemTypes.map((type: any) => `[${type.systemType.name}]`).join(' ')}
                </span>
              }
              key={index}
            >
              {/* Display history entries only if history exists */}
              {maintenance?.history?.length > 0 && (
                <div style={{ color: maintenance.history.includes('[Cerere reprogramare]') ? 'red' : 'inherit' }}>
                  {maintenance.history.map((entry: string, index: number) => {
                    const match = entry.match(/FISA: (\d+)/);
                    if (match) {
                      // Extract the number
                      return (
                        <React.Fragment key={index}>
                          <a
                            href={`/service-maintenance/interventionFile/edit?id=${maintenance?.interventionFileId}`} // Replace with your route
                            target='_blank'
                            rel='noopener noreferrer'
                          >
                            {entry}
                          </a>
                          <br />
                        </React.Fragment>
                      );
                    }
                    return (
                      <React.Fragment key={index}>
                        {entry}
                        <br />
                      </React.Fragment>
                    );
                  })}
                </div>
              )}
            </Panel>
          ))
        ) : (
          <p>Nici o mentenanta disponibila.</p>
        )}
      </Collapse>
    </Modal>
  );
};

export default MentenancePlanningHistoryModal;
